import { useState, FC, ReactNode } from "react"
import { faqs } from "../../data/faqData"
import { motion, AnimatePresence } from "framer-motion"
import { SvgCapterra, SvgStarRating } from "../../components/icons"
import MostRecommendedBadge from "../../assets/images/capterra-badges/sa-most_recommended-2023.png"
import BestValueBadge from "../../assets/images/capterra-badges/ca-value-2023.png"
import CustomerSupportBadge from "../../assets/images/capterra-badges/sa-customer_support-2023.png"

const FAQ: FC = () => {
  return (
    <div className="w-full">
      {faqs.map((faq, index) => (
        <FAQItem key={faq.id} title={faq.title} content={faq.content} />
      ))}
      <div className="mt-10 flex flex-col items-center gap-6">
        <div className="flex items-center gap-3 justify-center">
          <SvgCapterra className="w-14 h-14 text-[#0052CC]" />
          <SvgStarRating className="w-[140px] h-auto" />
        </div>
        <div className="flex flex-wrap justify-center gap-6">
          <img
            src={MostRecommendedBadge}
            alt="Most Recommended"
            className="h-[120px] w-auto"
          />
          <img
            src={BestValueBadge}
            alt="Best Value"
            className="h-[120px] w-auto"
          />
          <img
            src={CustomerSupportBadge}
            alt="Best Customer Support"
            className="h-[120px] w-auto"
          />
        </div>
      </div>
    </div>
  )
}

export default FAQ

type FAQItemProps = {
  title: string
  content: ReactNode
  isOpen?: boolean
}

const FAQItem: FC<FAQItemProps> = ({ title, content, isOpen = false }) => {
  const [showContent, setShowContent] = useState<boolean>(isOpen)

  return (
    <div
      onClick={() => setShowContent((prev) => !prev)}
      className="py-4 border-b border-gray-300 last:border-0 cursor-pointer"
    >
      <div className="flex justify-between items-start gap-4">
        <h4 className="text-lg sm:text-xl font-semibold text-left text-gray-900 leading-snug">
          {title}
        </h4>
        <div className="text-[28px] font-light text-gray-500 shrink-0">
          {showContent ? "−" : "+"}
        </div>
      </div>

      <AnimatePresence>
        {showContent && (
          <motion.div
            className="mt-2 text-sm text-gray-700 leading-relaxed"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            {content}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}
